export enum FEnsembleTypesEnum {
  Desktop = 1,
  Round = 2,
  Cabaret = 3,
  Boardroom = 4,
}
